//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import headingMixin from '~/mixins/headingMixin'
import parseTextMixin from '~/mixins/parseTextMixin'

export default {
  mixins: [headingMixin, parseTextMixin],

  inheritAttrs: false,

  props: {
    copy: {
      type: String,
      default: ''
    },

    primaryColour: {
      type: String,
      default: 'white',
      validator: (value) => {
        return [
          'white',
          'black'
        ].includes(value)
      }
    }
  },

  computed: {
    isSmallHeading () {
      return ['h3', 'h4', 'h5'].includes(this.headingSize)
    },

    classes () {
      return {
        BannerCard: true,
        [`Banner--${this.primaryColour}`]: this.primaryColour
      }
    }
  }
}
